// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

import {
  ManageClinics,
  ManageClinicDetails,
} from '../clinics/Management';
import {
  Authenticated,
} from '../auth';
import { ManageDocuments, ManageRoles, ManageUsers, ManageReferrals, ManageFax, ManageAppointmentAging, ManageReceivedFaxes } from './';
import ManageDocumentQuestions from './ManageDocumentQuestions';
import ManageReferralGroups from '../clinics/Management/ManageReferralGroups';
import ManageReferralGroupDetails from '../clinics/Management/ManageReferralGroupDetails';
import AddReferralGroup from '../clinics/Management/ReferralGroups/AddReferralGroup';

export default {
  path: 'manage',
  component: Authenticated,
  childRoutes: [
    {
      path: 'clinics',
      childRoutes: [
        { path: '', component: ManageClinics, props: {title: 'Manage Clinics', subtitle: 'Manage clinics and users'} },
        { path: ':id', 
          childRoutes: [
            { path: '', component: ManageClinicDetails, props: {title: 'Edit Clinic', subtitle: 'Manage clinics details and users'} },
          ],
        },
      ],
    },
    { path: 'roles', component: ManageRoles, props: {title: 'Manage Roles', subtitle: 'Manage Roles'} },
    { path: 'users', component: ManageUsers, props: {title: 'Manage Users', subtitle: 'Manage Users'} },
    { path: 'referral-networks', 
      childRoutes: [
        { path: '', component: ManageReferralGroups, props: {title: 'Manage Referral Groups', subtitle: 'Manage Referral Groups'} },
        { path: 'enroll', component: AddReferralGroup, props: {title: 'Create Referral Group', subtitle: 'Create Referral Group'}},
        { path: 'details/:id', component: ManageReferralGroupDetails, props: {title: 'Referral Group Details', subtitle: 'Referral Group Details'} },
      ]
    },
    {
      path: 'documents',
      childRoutes: [
        { path: '', component: ManageDocuments, props: {title: 'Manage Documents', subtitle: 'Manage Documents'} },
        { path: ':id', component: ManageDocumentQuestions, props: {title: 'Manage Document Questions', subtitle: 'Manage Document Questions'} },
      ],
    },
    { path: 'referrals', component: ManageReferrals, props: {title: 'Manage Referrals', subtitle: 'Manage Referrals'} },
    { path: 'fax', component: ManageFax, props: {title: 'Manage Fax', subtitle: 'Manage Fax'} },
    { path: 'appointment-aging', component: ManageAppointmentAging, props: {title: 'Appointment Aging', subtitle: 'Appointment Aging'} },
    { path: 'fax/received', component: ManageReceivedFaxes, props: {title: 'Received Faxes', subtitle: 'Received Faxes'} },
  ],
};
